import { render, staticRenderFns } from "./deanTextArea.vue?vue&type=template&id=4e49c07c&scoped=true"
import script from "./deanTextArea.vue?vue&type=script&lang=ts"
export * from "./deanTextArea.vue?vue&type=script&lang=ts"
import style0 from "./deanTextArea.vue?vue&type=style&index=0&id=4e49c07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e49c07c",
  null
  
)

export default component.exports